const doc = [({"da":({"js":({"merfoto":({"order_lines":({"edit":({"submit_image_button":({"save_in_basket":"Gem i indkøbskurven"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;